import { CoreState, HorizontalScrollType, ScrollDirection } from '../../models';

export function getInitialCoreState(): CoreState {
  return {
    userAcceptedQuery: '',
    coreStyles: {},
    dirtyInput: false,
    hasTabbed: false,
    inputQuery: '',
    open: false,
    openEmpathize: false,
    openFinished: false,
    openSortList: false,
    scrollDirection: ScrollDirection.UP,
    scrollEnabled: true,
    scrollOffset: false,
    firstGridItemIdInView: null,
    horizontalScrollType: HorizontalScrollType.DEFAULT,
    wishlist: [],
    stateLoadedFromCache: false
  };
}
